import { Pipe, PipeTransform } from '@angular/core';

import { isDefined } from '@shared/utils/is-defined';

@Pipe({
  name: 'isDefined',
  standalone: true,
})
export class IsDefinedPipe implements PipeTransform {
  public transform<T>(value: T): value is Exclude<T, undefined | null> {
    return isDefined(value);
  }
}
